import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PropTypes from "prop-types";

const useStyles = makeStyles({
  depositContext: {
    flex: 1,
    fontSize: '16px',
    lineHeight: '20px',
    marginTop: '8px',
    color:'#FFFFFFred',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  total: {
    fontSize: '36px',
    lineHeight: '44px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600'
  },
  containerTotal: {
    marginLeft: '10px',
    marginTop: '10px'
  }
});

Total.propTypes = {
  icon: PropTypes.elementType
};

export default function Total(props) {
  const classes = useStyles();
  const Icon = props.icon
  return (
    <div className={classes.containerTotal}>
      <Grid container spacing={2}>
        <Grid item xs = {8}>
          <Typography component="p" variant="h4" className={classes.total}>
            {props.total}
          </Typography>
        </Grid>
        <Grid item xs className={classes.icon}>
          {/* <img src={props.src} alt="devices" /> */}
          {/* <Icon /> */}
        </Grid>
      </Grid>
      <Typography color="textSecondary" className={classes.depositContext}>
         {props.leyenda}
      </Typography>
     </div>
  );
}